import { Box, Link, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export function TermsSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box textAlign="center" mt="24px">
      <Text fontSize="sm" color="neutral.400">
        {t("components.auth.signInToAgree")}{" "}
        <Link
          color="neutral.200"
          textDecoration="underline"
          onClick={() => navigate("/terms-of-use")}
        >
          {t("components.auth.terms")}
        </Link>
      </Text>
    </Box>
  );
}
